import React from 'react';
import styled from 'styled-components';
import {
  brandColours,
  minBreakpointQuery,
  sectionMargins,
  sectionPaddings,
} from '../styles';
import { Button, Container, Heading, HtmlContent } from './ui';

const StyledHighlightedContent = styled.section`
  text-align: center;
  ${sectionMargins('45px', '90px')};
`;

const StyledOuter = styled.div`
  ${sectionPaddings('45px', '90px')};
  background-color: ${brandColours.primary};
  position: relative;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  max-width: 92px;
  max-height: 98px;
  margin-bottom: 20px;

  ${minBreakpointQuery.small`
    margin-bottom: 25px;
  `}

  ${minBreakpointQuery.smedium`
    max-width: 138px;
    max-height: 147px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 30px;
    max-width: 184px;
    max-height: 196px;
  `}
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 20px;

  ${minBreakpointQuery.small`
    margin-bottom: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 30px;
  `}
`;

const StyledContent = styled(HtmlContent)``;

const StyledButton = styled(Button)`
  margin-top: 20px;
  width: 100%;
  max-width: 360px;

  ${minBreakpointQuery.small`
    margin-top: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 30px;
  `}
`;

const HighlightedContent = ({ image, heading, content, link }) => (
  <StyledHighlightedContent extend={image ? true : false}>
    <StyledOuter extend={image ? true : false}>
      <Container narrow={true}>
        {image && (
          <StyledImage src={image.url} alt={image.alt} loading="lazy" />
        )}
        <StyledHeading>{heading}</StyledHeading>
        <StyledContent content={content} />
        {link && <StyledButton to={link.pageUrl}>{link.text}</StyledButton>}
      </Container>
    </StyledOuter>
  </StyledHighlightedContent>
);

export default HighlightedContent;
